import Document from "../../components/document";
import Navbar from "../../components/common/NavBar";

export default function APIDocuments() {
  return (
    <>
      <Navbar />
      <Document />
    </>
  );
}
